import {
  DropdownCategory,
  HeaderFactoryParams,
} from "@/components/common/dropdown/data/dropdown-button-data";
import { useDropdownMenuWithOutsideClosing } from "@/hooks/use-dropdown-menu-with-outside-closing";
import styles from "@/components/common/dropdown/styles/dropdown-button.module.scss";
import { ReactNode } from "react";
import { createPortal } from "react-dom";

type DropdownButtonProps = {
  headerFactory: (params: HeaderFactoryParams) => ReactNode;
  categories: DropdownCategory[];
};

const DropdownButton = ({ headerFactory, categories }: DropdownButtonProps) => {
  const { dropdownRef, buttonRef, isOpen, setIsOpen } =
    useDropdownMenuWithOutsideClosing({});

  return (
    <>
      {headerFactory({ buttonRef, isOpen, setIsOpen })}
      {isOpen &&
        createPortal(
          <div className={styles.dropdown_content} ref={dropdownRef}>
            {categories.map((category, i) => (
              <div
                key={i}
                className={styles.category_wrapper}
                onClick={() => setIsOpen(false)}
              >
                {category.sections.map((section) => section)}
              </div>
            ))}
          </div>,
          document.body,
        )}
    </>
  );
};

export default DropdownButton;
